// Pure helpers for the Resident record panel.

export const SUGGEST_ROLES = ["company", "manager", "admin", "sadmin"];

const norm = (r) => String(r || "").toLowerCase();

/** Who may run the AI renewal suggestion: company, managers, and technical-staff leads. */
export const canSuggest = (role, lead) =>
  SUGGEST_ROLES.includes(norm(role)) || (norm(role) === "technical staff" && !!lead);

export const verdictTone = (v) => (v === "Recommend" ? "ok" : v === "Not recommended" ? "bad" : "soon");

export const money = (n) =>
  n == null ? "—" : `$${Number(n).toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const hoursLabel = (h) => (h == null ? "—" : h < 48 ? `${h} h` : `${Math.round(h / 24)} d`);

/** The suite-inspections page with the unit already chosen. */
export const newInspectionUrl = ({ propertyId, buildingName, unitNo }) =>
  `/suite-inspections?${new URLSearchParams({
    property_id: propertyId || "",
    building_name: buildingName || "",
    unit_number: unitNo || "",
  })}`;

/** The tiles in display order from a resident-record payload. */
export const tiles = (rec) => {
  const s = rec.snapshot;
  return [
    { key: "since", label: "Tenancy since", value: rec.tenancy.start || "—", block: "tenancy" },
    { key: "renewals", label: "Renewals", value: String(s.renewals), block: "tenancy" },
    { key: "tickets", label: "Maintenance calls", value: `${s.tickets_total} · ${s.tickets_12mo} in 12 mo`, block: "tickets" },
    { key: "nsf", label: "NSF", value: s.nsf ? `${s.nsf} · last ${s.nsf_last}` : "0", block: "nsf", tone: s.nsf ? "bad" : "" },
    { key: "incentives", label: "Incentives", value: `${s.incentives} · ${money(s.incentives_total)}`, block: "incentives" },
    { key: "addendums", label: "Addendums", value: String(s.addendums), block: "addendums" },
    {
      key: "inspection", label: "Last inspection", block: "inspections",
      value: s.last_inspection ? `${s.last_inspection.date} · ${s.last_inspection.overall_status || "—"}` : "—",
    },
  ];
};
